import { createContext, useContext } from 'react';

export type MeetingRoomContextValue = {
  leaveMeeting: () => void;
  /**
   * True once handleConnected has finished its initial microphone -> camera
   * publish sequence (whether each succeeded or failed). Screen-share auto-publish
   * waits for this so ScreenShare never negotiates ahead of Camera on connect.
   */
  initialMediaSettled?: boolean;
};

const MeetingRoomContext = createContext<MeetingRoomContextValue | null>(null);

export function useMeetingRoom() {
  const ctx = useContext(MeetingRoomContext);
  if (!ctx) {
    throw new Error('useMeetingRoom must be used within MeetingRoom');
  }
  return ctx;
}

export function useMeetingRoomOptional(): MeetingRoomContextValue | null {
  return useContext(MeetingRoomContext);
}

export { MeetingRoomContext };
